<template transition="expand">
  <div class="m-modal">
    <table>
      <tr>
        <th>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 712.13 244.72">
            <path class="cls-1" d="M93.14,0c0,37.62-1.76,74,.1,110.6C61.7,126.56,31.41,144.81,0,162.71V47.52Z"/>
            <path class="cls-2" d="M158.36,43.9c0-1.09.49-2.39-1.32-3.27a79.14,79.14,0,0,0-13,7.75c-8.41,4.74-16.75,9.61-25.26,14.15-3.39,1.81-4.65,4-4.53,7.92.46,14.49.3,29,1,43.46.31,7-2.37,11.09-8.27,14.36-12.54,6.93-25.09,13.82-38,20.09-3.55,1.73-5.08,3.87-5,8.09.34,13.82.15,27.65.19,41.48,0,1.41-.59,3,1.61,4.33l57.25-32c10.2-5.52,20.32-11.19,30.64-16.47,4.13-2.12,5.53-4.84,5.47-9.48C158.77,110.87,158.62,77.38,158.36,43.9Z"/>
            <path class="cls-3" d="M225.43,187.92c-.32-8.3-.15-16.61-.17-24.92-.06-25.43-.09-50.85-.23-76.27,0-1.35,1.4-4.09-2.13-3.48l-36.73,21.19c-3.36,1-5.58,2.74-5.26,6.7,1.34,16.76,1.61,33.54,1.29,50.35a10.63,10.63,0,0,1-5.22,6.79c-5.63,3.35-11.19,6.8-16.78,10.21a4.75,4.75,0,0,0,.29,1.06,4.75,4.75,0,0,1-.29-1.06l-15.1,7.94a76.73,76.73,0,0,0-12.85,6.19,2.77,2.77,0,0,0-1.6,2.85c0,16.06,0,32.12,0,49.25a244.09,244.09,0,0,0,24.52-13.27c5.57-3,11.16-5.92,16.68-9q24.22-13.41,48.41-26.89C224.39,194.67,225.59,192.07,225.43,187.92Z"/>
            <path class="cls-4" d="M274.51,219.93c-1.44-1.82-1-3.72-1-5.51,0-38.31.2-76.63,0-114.94-.12-21.16,6.59-38.49,25.42-49.82,24.75-14.89,63.26-12.7,83.88,9.92,7.79,8.55,12.43,18.58,12.48,30.22.21,41.81.2,83.62.25,125.43,0,1.47.19,3-.87,4.65-2.85.91-5.91.63-8.95.1-1.65-2.77-1.14-5.66-1.14-8.44,0-38.14.21-76.29-.19-114.43-.2-18.23-8.52-32.59-25-40.84-29.09-14.57-66.64-2.09-73.49,32.65a86.33,86.33,0,0,0-1.24,16.4c-.07,37.15,0,74.3,0,111.44a21.82,21.82,0,0,1-.41,3.05A22.66,22.66,0,0,1,274.51,219.93Z"/>
            <path class="cls-5" d="M519.06,210.15c-25-.46-50,.47-74.88-.63-9.7-1.24-17.2-5.17-19.21-15.76-.4-2.08-.61-4.2-.91-6.31l.14-53c1.83-.13,3.65-.37,5.48-.37q40.69,0,81.39,0c1.78,0,3.67.6,5.51-.83a15.63,15.63,0,0,0-.25-9.49c-6.44,0-12.73.05-19,0-24.29-.22-48.6.51-72.89-.36q-.06-34-.11-68h0c5.05-1.63,10.32.12,15.41-.93,2.14.18,4.29.5,6.44.51,14.66,0,29.32.09,44,0,6.15,0,12.32.52,18.44-.48a34.48,34.48,0,0,0,9.73,0c3.05-2.83.28-6.09.75-9.06-1.3-1.53-3.08-.94-4.66-.94q-48.33,0-96.65,0c-1.27,0-2.69-.45-3.69.83h0c-1.12,1.25-.83,2.79-.83,4.24q0,67.89,0,135.77c0,2.46-.39,5,.84,7.35.44,10.14,3.22,18.87,13.79,22.9,7.91,4.23,16.63,4.55,25.21,4.67,20.3.28,40.6.08,60.9.05,1.63,0,3.33.33,5.11-.8C520.71,216.63,520.58,213.53,519.06,210.15Z"/>
            <path class="cls-6" d="M620,40.24c50.82.3,88.7,36,91.83,84.22,2.45,37.75-11.31,68.43-44.44,88.15-41.91,24.95-100.77,11-123.67-38.36-16.45-35.44-13-69.95,10.94-101.09C571.83,50.8,595.74,40.64,620,40.24Zm3.61,11.12c-19.14-.45-35.55,6.61-49.63,19-31.11,27.4-39.57,72.29-13.07,109.93,23.39,33.22,68.28,43.18,101.27,22,28.23-18.09,44.9-53,37.21-87.12S660.31,50.9,623.63,51.36Z"/>
          </svg>

        </th>
      </tr>
      <tr>
        <td><input class="name" type='text' v-model="user.name" placeholder="Name" autofocus></td>
      </tr>
      <tr>
        <td><input class="password" type='password' v-model="user.password" placeholder="Password"></td>
      </tr>
      <tr>
        <td><btn class="btn" @click.native="login(user)">Login</btn></td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      user: {
        name: '',
        password: ''
      }
    }
  },
  computed: {
  },
  methods: {
    login (user) {
      this.$store.dispatch('login', this.user)
    }
  },
  mounted () {
  }
}
</script>

<style lang='scss' scoped>
.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
.m-modal {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.7);
  top: 0;
  left: 0;
  z-index: 1003;
}
table {
  border-spacing: 0;
  width: 400px;
  tr {
    th {
      color: #fff;
      font-size: 25px;
      padding: 10px;
    }
    td {
      input {
        outline: 0;
        border: none;
        font-size: 14px;
        color: #fff;
        width: 100%;
        height: 46px;
        background: none;
        border-bottom: solid 2px #ECEFF1;
        &:hover, &:focus {
        }
      }
      .btn {
        background: none;
        border: solid 2px #ECEFF1;
        margin-top: -4px;
        transition: none;
        &:hover, &:focus {
          /* background: #E91E63; */
          background: #263238;
          border-top: solid 2px #ECEFF1;
        }
      }
    }
  }
}

@keyframes svg_animation-1 {
    0% { }
   70% { opacity: 1; fill: #fff }
  100% { stroke-dashoffset: 100; opacity: 1; fill: #2E4053; stroke: #2E4053 }
}
@keyframes svg_animation-2 {
    0% { }
   70% { opacity: 1; fill: #fff }
  100% { stroke-dashoffset: 100; opacity: 1; fill: #39B178; stroke: #39B178 }
}
@keyframes svg_animation-3 {
    0% { }
   70% { opacity: 1; fill: #fff }
  100% { stroke-dashoffset: 100; opacity: 1; fill: #347665; stroke: #347665 }
}
@keyframes svg_animation-4 {
    0% { }
   70% { opacity: 1; fill: #fff }
  100% { stroke-dashoffset: 100; opacity: 1; fill: #fff }
}
@keyframes svg_animation-5 {
    0% { }
   70% { opacity: 1; fill: #fff }
  100% { stroke-dashoffset: 100; opacity: 1; fill: #fff }
}
@keyframes svg_animation-6 {
    0% { }
   70% { opacity: 1; fill: #fff }
  100% { stroke-dashoffset: 100; opacity: 1; fill: #fff }
}
svg {
  width: 50%;
  .cls-1 {
    /* fill: #fff; */
    opacity: 0;
    /* stroke: #2E4053; */
    stroke: #fff;
    stroke-width: 2;
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: svg_animation-1 3s linear 0s alternate forwards;
    -webkit-animation: svg_animation-1 3s linear 0s alternate forwards;
  }
  .cls-2 {
    /* fill: #fff; */
    opacity: 0;
    /* stroke: #39B178; */
    stroke: #fff;
    stroke-width: 2;
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: svg_animation-2 3s linear 0s alternate forwards;
    -webkit-animation: svg_animation-2 3s linear 0s alternate forwards;
  }
  .cls-3 {
    /* fill: #fff; */
    opacity: 0;
    /* stroke: #347665; */
    stroke: #fff;
    stroke-width: 2;
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: svg_animation-3 3s linear 0s alternate forwards;
    -webkit-animation: svg_animation-3 3s linear 0s alternate forwards;
  }
  .cls-4 {
    /* fill: #fff; */
    opacity: 0;
    /* stroke: #314158; */
    stroke: #fff;
    stroke-width: 2;
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: svg_animation-4 3s linear 0s alternate forwards;
    -webkit-animation: svg_animation-4 3s linear 0s alternate forwards;
  }
  .cls-5 {
    /* fill: #fff; */
    opacity: 0;
    /* stroke: #314158; */
    stroke: #fff;
    stroke-width: 2;
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: svg_animation-5 3s linear 0s alternate forwards;
    -webkit-animation: svg_animation-5 3s linear 0s alternate forwards;
  }
  .cls-6 {
    /* fill: #fff; */
    opacity: 0;
    /* stroke: #314158; */
    stroke: #fff;
    stroke-width: 2;
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: svg_animation-6 3s linear 0s alternate forwards;
    -webkit-animation: svg_animation-6 3s linear 0s alternate forwards;
  }
}
</style>



// WEBPACK FOOTER //
// LogIn.vue?7db2452e